import React, {useReducer, useEffect} from 'react';

import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import reducer, {getInitialState} from '@/b2b/pages/ServiceRecord/state';
import {ServiceRecordCtx} from '@/b2b/contexts';

import {SortLabelHint} from '@/b2b/components/LegendList';

import ServiceRecordList from '@/b2b/pages/ServiceRecord/ServiceRecordList';
import SearchBox from '@/b2b/pages/ServiceRecord/SearchBox';

const ServiceRecordContext = ({children}) => {
  const [producer] = useProducerCtx();
  const [state, dispatch] = useReducer(reducer, getInitialState(producer));

  useEffect(
    () => {
      dispatch({
        type: 'changeProducer',
        payload: {
          manager: producer.producerFullName,
          selectedProducerId: producer.producerId,
        },
      });
    },
    [producer]
  );

  return (
    <ServiceRecordCtx.Provider value={[state, dispatch]}>
      {children}
    </ServiceRecordCtx.Provider>
  );
};

const ServiceRecord = () => (
  <ServiceRecordContext>
    <SearchBox />
    <SortLabelHint />
    <ServiceRecordList />
  </ServiceRecordContext>
);

export default ServiceRecord;
